import { Component, Input } from '@angular/core';

@Component({
  selector: 'common-close-icon',
  templateUrl: './close-icon.component.svg',
  styleUrls: ['./close-icon.component.scss'],
})
export class CloseIconComponent {
  @Input() backgroundColor = '#E9E9ED';
  @Input() strokeColor = '#7A89AD';
  @Input() height = 26;
  @Input() width = 26;
}
